import React from 'react'
import { Link } from 'react-router-dom'
import BamboraSvgIcon from './bamboraSvgIcon'

const Notification = ({ msgText, linkText, linkUrl, closeAction }) => {
    msgText = msgText ? msgText : ''
    return (
        <div className="notification-wrapper">
            <div className="notification-banner-message">
                {msgText}
                {linkText && linkUrl &&
                    <Link
                        to={linkUrl} >
                        {linkText}
                    </Link>
                }
                {closeAction &&
                    <BamboraSvgIcon
                        icon="close-thin"
                        onClick={closeAction}
                        className="notification-close"
                    />
                }
            </div>
        </div>
    )
}

export default Notification
